import styles from "./Input.module.scss"
import FormLabel from "@mui/material/FormLabel"
import TextField from "@mui/material/TextField"
import FormControl from "@mui/material/FormControl"
import Box from "@mui/material/Box"
import InputAdornment from "@mui/material/InputAdornment"
import Typography from "@mui/material/Typography"

type InputProps = {
    label?: string
    placeholder?: string
    varient?: string
    type?: string
    value?: string | number
    [key: string]: any
    required?: boolean
    style?: any
    labelFontWeight?: any
    disabled?: boolean
    icon?: string
    tooltipText?: any
    autoFocus?: any
    text?: string
    name?: string
    description?: any
    subLabelStyle?: any
}

const style = {
    margin: "16px 0px",
    "& .MuiTextField-root": {
        width: "100%",
    },
}

const Input = (props: InputProps) => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
            <FormControl sx={props.style ? props.style : style}>
                <FormLabel
                    disabled={props?.disabled}
                    id={props?.name}
                    sx={{ fontWeight: props?.labelFontWeight, width: "100%" }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <Typography>
                            {props?.label}
                        </Typography>
                        {props?.required && <Typography sx={{ color: "#E20000", fontSize: "14px", fontWeight: 500 }}>*</Typography>}
                    </Box>
                    {props?.description === undefined ? (
                        <TextField
                            autoFocus={props?.autoFocus}
                            multiline={props.type === "textarea"}
                            InputProps={{
                                autoFocus: props?.autoFocus,
                                className: props.disabled ? styles.input__disabled : styles.input,
                                endAdornment: props?.endAdornmentText && (
                                    <InputAdornment position="end" sx={{ width: "70px", border: "0.5px solid #C3C3C3", borderRadius: "4px", textAlign: "center" }}>
                                        <Typography className={styles.input__end_adornment_text}>
                                            {props?.endAdornmentText}
                                        </Typography>
                                    </InputAdornment>
                                ),
                            }}
                            FormHelperTextProps={{
                                classes: {
                                    root: styles.input__error_message,
                                },
                            }}
                            sx={{
                                ...(props.type === "textarea" && {
                                    "& .MuiOutlinedInput-root": {
                                        height: "8em",
                                        padding: 0,
                                        width: "100%"
                                    },
                                    "& .MuiOutlinedInput-input": {
                                        width: "100%",
                                        boxSizing: "border-box",
                                        height: "100% !important",
                                        overflowY: "auto !important",
                                        wordBreak: "break-all",
                                    },
                                }),
                                // borderRadius: "8px",
                            }}
                            type={props.type}
                            placeholder={props.placeholder}
                            variant="standard"
                            {...props}
                            label=""
                            disabled={props?.disabled}
                            required={props?.required}
                        />
                    ) : (
                        props?.description
                    )}
                </FormLabel>
                {props?.subLabel && (
                    <FormLabel
                        disabled={props?.disabled}
                        id={props?.name}
                        sx={props?.subLabelStyle}
                        required={props?.required}
                    >
                        {props.subLabel}
                    </FormLabel>
                )}
                {props?.text && <Typography className={styles.input_text}>{props?.text}</Typography>}
            </FormControl>
        </Box>
    )
}

export default Input
